import LegalLayout from '../components/LegalLayout';

const SECTIONS = [
  { type: 'p', text: 'How ShiftCover365 uses cookies, local storage and similar technologies — aligned with the live platform.' },

  { type: 'h1', text: '1. Introduction' },
  { type: 'p', text: 'This Cookie Policy explains how ShiftCover365 uses cookies, browser local storage and similar technologies on its website and platform. It also describes what we do not use.' },

  { type: 'h1', text: '2. What Are Cookies and Local Storage?' },
  { type: 'p', text: 'Cookies are small files stored on your device by your browser. Local storage is a similar browser-side storage mechanism that does not use HTTP cookies. Both help websites remember information, keep users signed in, protect accounts and improve performance.' },

  { type: 'h1', text: '3. What ShiftCover365 Actually Uses Today' },
  { type: 'p', text: 'ShiftCover365 does not currently set HTTP cookies for analytics, advertising or marketing. The platform uses browser local storage for two strictly-necessary purposes:' },
  { type: 'ul', items: [
    'Session token — a signed JWT authentication token that keeps you signed in. It is cleared when you sign out.',
    'Walkthrough preference — a flag that records whether you have completed the in-app onboarding walkthrough, so you do not see it again unless you choose to replay it.',
  ] },
  { type: 'p', text: 'No third-party analytics scripts, advertising trackers, marketing pixels or social-network share cookies are installed on the platform at this time.' },

  { type: 'h1', text: '4. Strictly-Necessary Storage' },
  { type: 'p', text: 'The session token described above is strictly necessary for the platform to work — without it, you cannot stay signed in or access the protected areas of the app. Disabling local storage in your browser will prevent ShiftCover365 from functioning.' },

  { type: 'h1', text: '5. Analytics, Advertising and Marketing' },
  { type: 'p', text: 'ShiftCover365 is not currently integrated with any analytics, advertising or marketing provider, and does not set any cookies or storage entries for those purposes. If we add analytics in future, this policy will be updated and a clear consent option will be added to the site before any non-essential tracking is enabled.' },

  { type: 'h1', text: '6. Third-Party Services' },
  { type: 'p', text: 'Some third-party services we rely on may set their own cookies or use similar technologies when you interact with their domains:' },
  { type: 'ul', items: [
    'Stripe — when payment flows are loaded, Stripe may set cookies on its own domain to support fraud prevention and secure payment processing.',
    'Resend — handles transactional email delivery server-side and does not set cookies in your browser.',
    'Emergent — hosts the platform; standard infrastructure security cookies may be set during traffic protection.',
  ] },
  { type: 'p', text: 'These cookies are governed by the respective providers\u2019 own privacy and cookie policies.' },

  { type: 'h1', text: '7. Managing Cookies and Local Storage' },
  { type: 'p', text: 'You can control cookies and local storage through your browser settings — most browsers allow blocking, deleting or limiting them. Blocking the storage used by ShiftCover365 (the session token) will prevent you from staying signed in.' },

  { type: 'h1', text: '8. Changes to This Policy' },
  { type: 'p', text: 'We may update this Cookie Policy as the platform develops, especially if cookie or storage usage changes. The effective date at the top of this page will be updated accordingly.' },

  { type: 'h1', text: '9. Contact' },
  { type: 'p', text: 'Questions about cookies or local storage may be sent to: support@shiftcover365.co.uk.' },
];

export default function CookiesPage() {
  return (
    <LegalLayout
      title="Cookie Policy"
      subtitle="Cookies, local storage and similar technologies — what ShiftCover365 actually uses."
      effectiveDate="16 February 2026"
      sections={SECTIONS}
    />
  );
}
